import { render, staticRenderFns } from "./Pos_page.vue?vue&type=template&id=22aa8634&scoped=true&"
import script from "./Pos_page.vue?vue&type=script&lang=js&"
export * from "./Pos_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aa8634",
  null
  
)

export default component.exports